import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Space, Row, Col, DatePicker } from 'antd';
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import moment from 'moment';
import { updateCustomerProspect, createCustomerProspect } from '@/redux/actions/customerProspectsActions';
import { getListWards } from '@/redux/actions/regionsActions';

class CustomerProspectForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            wards: []
        };
    }

    componentDidUpdate(prevProps) {
        // currentItem thay đổi
        if (prevProps.currentItem !== this.props.currentItem) {
            const cur = this.props.currentItem;

            // Nếu chuyển sang tạo mới -> clear wards
            if (!cur) {
                this.setState({ wards: [] });
                return;
            }

            // Nếu có province_code -> load wards
            if (cur?.province_code) {
                this.props
                    .getListWards({ province_code: cur.province_code })
                    .then(res => this.setState({ wards: res?.data || [] }))
                    .catch(() => this.setState({ wards: [] }));
            } else {
                this.setState({ wards: [] });
            }
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields(async (err, values) => {
            if (err) return;

            this.setState({ isLoading: true });

            try {
                // Năm sinh: picker="year" => lưu 'YYYY' cho đúng nghĩa
                values.birthday = values.birthday ? values.birthday.format("YYYY") : null;

                if (this.props.currentItem) {
                    await this.props.updateCustomerProspect(this.props.currentItem.id, values);
                } else {
                    await this.props.createCustomerProspect(values);
                }

                this.onClose();
            } catch (error) {
                this.setState({ isLoading: false });
            }
        });
    };

    onClose = () => {
        this.props.reloadData();
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false, wards: [] });
    };

    loadWards = (province_code) => {
        if (!province_code) {
            this.props.form.setFieldsValue({ ward_code: undefined });
            this.setState({ wards: [] });
            return;
        }

        this.props.getListWards({ province_code }).then(res => {
            this.props.form.setFieldsValue({ ward_code: undefined }); // clear chắc hơn null
            this.setState({ wards: res?.data || [] });
        }).catch(() => {
            this.props.form.setFieldsValue({ ward_code: undefined });
            this.setState({ wards: [] });
        });
    };

    getBirthdayInitialValue = (currentItem) => {
        if (!currentItem?.birthday) return null;

        const b = String(currentItem.birthday).trim();

        // Nếu backend lưu "YYYY"
        if (/^\d{4}$/.test(b)) {
            return moment(b, 'YYYY', true);
        }

        // Nếu backend lưu "YYYY-MM-DD" hoặc dạng ngày khác -> lấy năm
        const m = moment(b);
        if (m.isValid()) {
            return moment(m.format('YYYY'), 'YYYY', true);
        }

        return null;
    };

    render() {
        const { isLoading, wards } = this.state;
        const { visible, currentItem, filterData } = this.props;
        const { getFieldDecorator } = this.props.form;

        const provinces = filterData?.provinces;
        const customerStatus = filterData?.statuses;
        const groups = filterData?.groups;

        return (
            <Drawer
                visible={visible}
                title={`${currentItem ? `Sửa khách hàng: ${currentItem?.full_name}` : "Thêm khách hàng"}`}
                onClose={this.onClose}
                maskClosable={false}
                width={isMobile ? '100%' : '60%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Space>
                            <Button key="back" size="large" onClick={this.onClose}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                size="large"
                                onClick={this.handleSubmit}
                            >
                                {currentItem ? 'Cập nhật' : 'Thêm mới'}
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ? (
                    <Form layout="vertical">
                        <Row gutter={16} className="mt-4">
                            <Col xs={24} md={8}>
                                <Form.Item label="Tên khách hàng">
                                    {getFieldDecorator('full_name', {
                                        rules: [{ required: true, message: 'Vui lòng điền!' }],
                                        initialValue: currentItem ? currentItem.full_name : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Số điện thoại">
                                    {getFieldDecorator("phone", {
                                        initialValue: currentItem ? currentItem.phone : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Nhóm">
                                    {getFieldDecorator('group_ids', {
                                        initialValue: currentItem ? (currentItem.group_ids || []) : [],
                                    })(
                                        <BaseSelect
                                            options={groups ?? []}
                                            optionValue="id"
                                            optionLabel="name"
                                            placeholder="Chọn 1 hoặc nhiều nhóm"
                                            showSearch
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Giới tính">
                                    {getFieldDecorator("gender", {
                                        initialValue: currentItem ? currentItem.gender : null
                                    })(
                                        <BaseSelect
                                            options={[
                                                { label: "Nam", value: 'Nam' },
                                                { label: "Nữ", value: 'Nữ' },
                                                { label: "Khác", value: 'Khác' }
                                            ]}
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Mã số thẻ cũ">
                                    {getFieldDecorator("card_number", {
                                        initialValue: currentItem ? currentItem.card_number : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Năm sinh">
                                    {getFieldDecorator('birthday', {
                                        initialValue: this.getBirthdayInitialValue(currentItem),
                                    })(
                                        <DatePicker
                                            picker="year"
                                            style={{ width: '100%' }}
                                            placeholder="Chọn"
                                            format="YYYY"
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Tỉnh/Thành phố">
                                    {getFieldDecorator("province_code", {
                                        initialValue: currentItem ? currentItem.province_code : null,
                                        normalize: value => (value !== undefined ? value : null),
                                    })(
                                        <BaseSelect
                                            options={provinces || []}
                                            optionValue="code"
                                            optionLabel="name"
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                            onChange={this.loadWards}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Phường/Xã">
                                    {getFieldDecorator("ward_code", {
                                        initialValue: currentItem ? currentItem.ward_code : null,
                                        normalize: value => (value !== undefined ? value : null),
                                    })(
                                        <BaseSelect
                                            options={wards || []}
                                            optionValue="code"
                                            optionLabel="name"
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Tổ">
                                    {getFieldDecorator("residential_group", {
                                        initialValue: currentItem ? currentItem.residential_group : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Địa chỉ">
                                    {getFieldDecorator('address', {
                                        initialValue: currentItem ? currentItem.address : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={8}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator("customer_status_id", {
                                        initialValue: currentItem ? currentItem.customer_status_id : null,
                                        normalize: value => (value !== undefined ? value : null),
                                    })(
                                        <BaseSelect
                                            options={customerStatus || []}
                                            optionValue="id"
                                            optionLabel="name"
                                            showSearch
                                            placeholder="Chọn một bản ghi"
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                ) : null}
            </Drawer>
        );
    }
}

function mapStateToProps(state) {
    return {
        filterData: state.filterReducer.list
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateCustomerProspect: (id, data) => dispatch(updateCustomerProspect(id, data)),
        createCustomerProspect: (data) => dispatch(createCustomerProspect(data)),
        getListWards: (filter) => dispatch(getListWards(filter)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: 'CustomerProspectForm' })(CustomerProspectForm));